import { Routes } from '@angular/router';
import { PermissionGuard } from '../guards/permission.guard';
import { Permissions } from '../constants/permissions';

export const Full_Content_Routes: Routes = [
  {
    path: 'access-denied',
    loadChildren: () =>
      import('../../modules/access-denied/access-denied.module').then(
        (m) => m.AccessDeniedModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('../../dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.DashboardView },
  },
  {
    path: 'ads',
    loadChildren: () =>
      import('../../modules/Ads/ads.module').then((m) => m.AdsModule),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.AdsView },
  },
  {
    path: 'providers',
    loadChildren: () =>
      import('../../modules/providers/providers.module').then(
        (m) => m.ProvidersModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.ProvidersView },
  },
  {
    path: 'candidates',
    loadChildren: () =>
      import('../../modules/candidates/candidates.module').then(
        (m) => m.CandidatesModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.CandidatesView },
  },
  {
    path: 'interviews',
    loadChildren: () =>
      import('../../modules/interviews/interviews.module').then(
        (m) => m.InterviewsModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.InterviewsView },
  },
  {
    path: 'cvs',
    loadChildren: () =>
      import('../../modules/cvs/cvs.module').then((m) => m.CvsModule),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.CvsView },
  },
  {
    path: 'workshops',
    loadChildren: () =>
      import('../../modules/workshops/workshops.module').then(
        (m) => m.WorkshopsModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.WorkshopsView },
  },
  {
    path: 'process-orders',
    loadChildren: () =>
      import('../../modules/process-orders/process-orders.module').then(
        (m) => m.ProcessOrdersModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.PackagesProcessView },
  },
  {
    path: 'opportunities',
    loadChildren: () =>
      import('../../modules/opportunities/opportunities.module').then(
        (m) => m.OpportunitiesModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.OpportunitiesView },
  },
  {
    path: 'collection-sources',
    loadChildren: () =>
      import('../../modules/collection-sources/collection-sources.module').then(
        (m) => m.CollectionSourcesModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.CollectionSourcesManage },
  },
  {
    path: 'collection-drafts',
    redirectTo: '/opportunities',
    pathMatch: 'full',
  },
  {
    path: 'collection-drafts/:id',
    redirectTo: '/opportunities/draft/:id',
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('../../modules/Reports/reports-management.module').then(
        (m) => m.ReportsManagementModule
      ),
  },
  {
    path: 'moderators',
    loadChildren: () =>
      import('../../modules/moderators/moderators.module').then(
        (m) => m.ModeratorsModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.ModeratorsView },
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('../../modules/campaigns/campaigns.module').then(
        (m) => m.CampaignsModule
      ),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('../../modules/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'requests',
    loadChildren: () =>
      import('../../modules/contact-requests/contact-requests.module').then(
        (m) => m.ContactRequestsModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.RequestsView },
  },
  {
    path: 'company-interests',
    loadChildren: () =>
      import('../../modules/company-interests/company-interests.module').then(
        (m) => m.CompanyInterestsModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.RequestsView },
  },
  {
    path: 'payments',
    loadChildren: () =>
      import('../../modules/payments/payments.module').then(
        (m) => m.PaymentsModule
      ),
    canActivate: [PermissionGuard],
    data: { permission: Permissions.PaymentsView },
  },
  {
    path: '',
    loadChildren: () =>
      import('../../modules/system/system.module').then((m) => m.SystemModule),
  },
];
